import React from 'react';
import { Link } from 'react-router-dom';
import './SponsorsSection.css';

const sponsors = [
  {
    name: 'Liberty Debt Relief',
    href: 'https://libertydebtrelief.com/',
    logoSrc: '/sponsor-logos/liberty-debt-relief.svg',
    logoClass: 'sponsor-logo--liberty'
  },
  {
    name: 'Jammal Law Firm',
    href: 'https://jammalesq.com/',
    logoSrc: '/sponsor-logos/jammal-law-firm.svg',
    logoClass: 'sponsor-logo--jammal'
  },
  {
    name: 'Starbuzz Tobacco',
    href: 'https://shopstarbuzz.com/',
    logoSrc: '/sponsor-logos/starbuzz-tobacco.svg',
    logoClass: 'sponsor-logo--starbuzz'
  },
  {
    name: 'Blu',
    href: 'https://www.drinkblu.com/',
    logoSrc: '/sponsor-logos/blue-energy-drink.svg',
    logoClass: 'sponsor-logo--blu'
  },
  {
    name: 'Empi.re',
    href: 'https://empi.re/',
    logoSrc: '/sponsor-logos/empire.svg',
    logoClass: 'sponsor-logo--empire'
  },
  {
    name: 'Watermelon Pictures',
    href: 'https://www.watermelonpictures.com/',
    logoSrc: '/sponsor-logos/watermelon-pictures.svg'
  },
  {
    name: 'CAIR',
    href: 'https://ca.cair.com/',
    logoSrc: '/sponsor-logos/cair.svg',
    logoClass: 'sponsor-logo--cair'
  }
];

const SponsorsSection = () => {
  return (
    <section className="sponsors-section">
      <h3>Sponsors</h3>
      <div className="sponsors-logos">
        {sponsors.map((sponsor) => (
          <a key={sponsor.name} href={sponsor.href} target="_blank" rel="noopener noreferrer" title={sponsor.name}>
            <img loading="lazy" src={sponsor.logoSrc} alt={sponsor.name} className={`sponsor-logo ${sponsor.logoClass || ''}`.trim()} />
          </a>
        ))}
      </div>
      <Link to="/sponsors" className="white-link" title="View all sponsors">View all</Link>
    </section>
  );
};

export default SponsorsSection;
